import { render } from "./Recordatorios-App.vue?vue&type=template&id=4f0c33de&scoped=true"
import script from "./Recordatorios-App.vue?vue&type=script&lang=js"
export * from "./Recordatorios-App.vue?vue&type=script&lang=js"

import "./Recordatorios-App.vue?vue&type=style&index=0&id=4f0c33de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0c33de"]])

export default __exports__